import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaGlobe, FaFacebookF, FaInstagram } from "react-icons/fa";
import "./AboutPage.css";

const AboutPage = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [showLangMenu, setShowLangMenu] = useState(false);

  // Soft ambient glow that follows the cursor (متطابق مع الـ Homepage)
  const containerRef = useRef(null);
  const handleMouseMove = useCallback((e) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty("--glow-x", `${e.clientX - rect.left}px`);
    el.style.setProperty("--glow-y", `${e.clientY - rect.top}px`);
  }, []);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.dir = lang === "ar" ? "rtl" : "ltr";
    setShowLangMenu(false);
  };

  return (
    <div className="aboutpage-container" ref={containerRef} onMouseMove={handleMouseMove}>
      <div className="ambient-glow" aria-hidden="true" />

      {/* Language Switcher in the top right corner */}
      <div className="about-topbar">
        <div className="lang-switcher">
          <button
            type="button"
            className="lang-toggle"
            onClick={() => setShowLangMenu((v) => !v)}
            aria-haspopup="listbox"
            aria-expanded={showLangMenu}
          >
            <FaGlobe />
            <span>{i18n.language === "ar" ? "AR" : "EN"}</span>
          </button>
          {showLangMenu && (
            <div className="lang-dropdown" role="listbox">
              <div role="option" onClick={() => changeLanguage("en")}>English</div>
              <div role="option" onClick={() => changeLanguage("ar")}>العربية</div>
            </div>
          )}
        </div>
      </div>

      <div className="aboutpage-main">
        <header className="reveal" style={{ "--delay": "0s" }}>
          <span className="eyebrow">// EMKA — architecture</span>
          <h1>{t("About EMKA DEV")}</h1>
        </header>

        <section className="reveal" style={{ "--delay": "0.1s" }}>
          <h3>{t("Company Introduction")}</h3>
          <p>{t("Company Intro Text")}</p>
        </section>

        <section className="reveal" style={{ "--delay": "0.2s" }}>
          <h3>{t("The EMKA DEV Story")}</h3>
          <div className="aboutpage-card">
            <h4>{t("Founded in 2024")}</h4>
            <p>{t("Founded Text")}</p>
          </div>
        </section>

        <section className="aboutpage-mission-vision reveal" style={{ "--delay": "0.3s" }}>
          <div className="aboutpage-card aboutpage-card-border-primary">
            <h4>{t("Our Mission")}</h4>
            <p>{t("Mission Text")}</p>
          </div>
          <div className="aboutpage-card aboutpage-card-border-secondary">
            <h4>{t("Our Vision")}</h4>
            <p>{t("Vision Text")}</p>
          </div>
        </section>

        <section className="reveal" style={{ "--delay": "0.4s" }}>
          <h3>{t("Core Values")}</h3>
          <div className="aboutpage-core-values">
            {[
              { label: "Innovation", icon: "💡" },
              { label: "Reliability", icon: "✔️" },
              { label: "User-Centric Design", icon: "🎨" },
              { label: "Transparency & Trust", icon: "🤝" },
              { label: "Agility", icon: "⚡" },
            ].map((item) => (
              <div key={item.label} className="aboutpage-core-values-item">
                <span>{item.icon}</span>
                <span>{t(item.label)}</span>
              </div>
            ))}
          </div>
        </section>

        <section className="aboutpage-cta reveal" style={{ "--delay": "0.5s" }}>
          <button onClick={() => navigate("/contact")}>
            {t("Start Your Project Today →")}
          </button>
        </section>

        {/* Social media icons placed at the bottom center */}
       <div className="bottom-social-row reveal">
          <a
            href="https://www.facebook.com/EmkaCode.tech"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FaFacebookF />
          </a>

          <a
            href="https://www.instagram.com/emkacode/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;